//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SpriteIcon from "../elements/SpriteIcon";

export default {
    components: {
        SpriteIcon,
    },
    props: {
        pricing: {
            type: Object,
            required: true,
        }
    },
}
